import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  Button,
  Container,
  Divider,
  DropdownMenuGroup,
  DropdownMenuItem,
  Icon,
  InputCheckbox,
  Notifications,
  SearchBox,
  Skeleton,
  Text,
} from "@jds/core";

import { Box } from "@mui/material";

// Local
import JdsMenu from "../../JdsMenu";
import GreyDropDownButton from "../../Buttons/GreyDropDownButton";
import useApiHttp from "../../../../hooks/use-http";
import { useParams } from "react-router-dom";
import EmptyState from "../../../NoData/EmptyState";

const LayoutSkeleton = () => {
  return (
    <Container direction="column" fullWidth>
      <Container
        horizontalAlign="space-between"
        verticalAlign="center"
        fullWidth
      >
        <Skeleton width={250} animated shape="heading" />
        <Skeleton width={50} animated shape="paragraph" />
      </Container>
      <Divider pad="medium" padPosition="vertical" />
      <Container
        horizontalAlign="space-between"
        verticalAlign="center"
        fullWidth
      >
        <Skeleton width={150} animated shape="paragraph" />
        <Skeleton width={100} animated shape="paragraph" />
      </Container>

      <Container
        direction="column"
        fullWidth
        gap={16}
        style={{ marginTop: "32px" }}
      >
        <Skeleton width="100%" animated shape="paragraph" />
        <Skeleton width="100%" animated shape="paragraph" />
        <Skeleton width="100%" animated shape="paragraph" />
      </Container>
    </Container>
  );
};

export default function ApproveRegisteration(props) {
  const { id: eventId } = useParams();
  const [guestData, setGuestData] = useState();
  const [guestList, setGuestList] = useState([]);
  const [selectedGuests, setSelectedGuests] = useState([]);
  const [isSelectedAll, setisSelectedAll] = useState(false);
  const [nameQuery, setNameQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);

  const { sendRequest: getGuestDataAPI, isLoading } = useApiHttp();
  const { sendRequest: giveAccessAPI, isSharingAccess } = useApiHttp();
  const { sendRequest: searchGuestApi, isSearching } = useApiHttp();
  const controller = new AbortController();
  const getGuest = (currentPage) => {
    getGuestDataAPI(
      {
        url: `event-attendee/register/${eventId}/guests?page=${currentPage}&size=10`,
      },
      (data) => {
        setGuestData(data);
        setLastPage(data?.lastPage);
        if (isSelectedAll) {
          const updatedData = data?.results.map((item) => {
            return {
              ...item,
              isSelected: true,
            };
          });

          setGuestList((pre) => [...pre, ...updatedData]);

          const updatedSelectedGuests = data?.results.map((item) => item?.id);
          setSelectedGuests((pre) => [...pre, ...updatedSelectedGuests]);
        } else {
          if (currentPage === 0) {
            setGuestList(data?.results);
          } else {
            setGuestList((pre) => [...pre, ...data?.results]);
          }
        }
      }
    );
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setisSelectedAll(isChecked);

    console.log(
      guestList.map((item) => {
        return {
          ...item,
          isSelected: isChecked,
        };
      })
    );

    if (isChecked) {
      setSelectedGuests(guestList.map((item) => item.id));
    } else {
      setSelectedGuests([]);
    }

    setGuestList(
      guestList.map((item) => {
        return {
          ...item,
          isSelected: isChecked,
        };
      })
    );
  };

  const handleCheckboxChange = (guestId, isChecked) => {
    if (isChecked) {
      setSelectedGuests((prevSelected) => {
        return [...prevSelected, guestId];
      });
      setGuestList(
        guestList.map((item) =>
          item.id === guestId ? { ...item, isSelected: true } : item
        )
      );
    } else {
      if (selectedGuests.length == 1) {
        handleSelectAllChange({ target: { checked: false } });
      } else {
        setisSelectedAll(false);
      }
      setSelectedGuests((prevSelected) => {
        return prevSelected.filter((id) => id !== guestId);
      });
    }
  };

  const handleScroll = useCallback(
    (e) => {
      const scrollHeight = document?.querySelector(
        "#share-container-scroll-div"
      ).scrollHeight;
      const currentHeight =
        document?.querySelector("#share-container-scroll-div").scrollTop +
        window.innerHeight;
      if (currentHeight + 300 >= scrollHeight && currentPage < lastPage) {
        setCurrentPage(currentPage + 1);
      }
    },
    [currentPage, lastPage]
  );

  const searchGuestHandler = (currentPage, searchValue) => {
    searchGuestApi(
      {
        url: `event-attendee/attendees_search/${eventId}/REGISTERED?nameQuery=${searchValue}&page=${currentPage}&size=10`,
      },
      null,
      (data) => {
        if (currentPage == 0) {
          setGuestData(data);
          setGuestList(data?.data);
          setLastPage(data?.lastPage);
        } else {
          setGuestData(data);
          setGuestList((prev) => [...prev, ...data?.data]);
          setLastPage(data?.lastPage);
        }
      }
    );
  };

  const giveApproveHandler = (registerStatus) => {
    giveAccessAPI(
      {
        url: `event-attendee/update-register-status-multiple`,
        method: "POST",
        body: {
          eventId,
          registerStatus,
          userIds: selectedGuests,
          isSelectedAll,
        },
      },
      null,
      (data) => {
        Notifications.toast.success(data?.message);

        const updatedGuestList = guestList.map((item) =>
          selectedGuests.includes(item.id)
            ? {
                ...item,
                isSelected: false,
              }
            : item
        );
        console.log(updatedGuestList);
        handleSelectAllChange({ target: { checked: false } });
        setGuestList([]);
        setSelectedGuests([]);
        props?.onSuccess && props.onSuccess();
      }
    );
  };

  useEffect(() => {
    // Update isSelectedAll based on the selectedGuests length and guestList length

    if (selectedGuests.length === guestData?.count) {
      console.log("select ALL true");
      setisSelectedAll(true);
    }
    console.log("selectedGuests", selectedGuests);
    //  else {
    //   !isSelectedAll && setisSelectedAll(false);
    // }
  }, [selectedGuests]);

  useEffect(() => {
    if (nameQuery.length) {
      searchGuestHandler(currentPage, nameQuery);
    } else {
      getGuest(currentPage);
    }
    return () => {
      controller.abort();
    };
  }, [currentPage, nameQuery]);
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > currentPage) {
          setCurrentPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [isLoading, lastPage]
  );
  return (
    <>
      {isLoading && !guestList.length ? (
        <LayoutSkeleton />
      ) : (
        <Box>
          <Container
            horizontalAlign="space-between"
            verticalAlign="center"
            fullWidth
            {...props?.headerProps}
          >
            <Box width={"100%"}>
              <SearchBox
                label="Search "
                prefix="IcSearch"
                value={nameQuery}
                onChange={(e) => {
                  const searchValue = e.target.value;
                  setCurrentPage(0);
                  setNameQuery(searchValue);

                  if (searchValue.length) {
                    searchGuestHandler(0, searchValue);
                  } else {
                    getGuest(currentPage);
                  }
                }}
              />
            </Box>
          </Container>
          {guestList?.length > 0 && (
            <Box
              mt={4}
              sx={{
                "& .j-JDSCheckbox-horizontal-container": {
                  gap: "14px",
                },
              }}
              onClick={() => {
                if (
                  selectedGuests.length &&
                  selectedGuests.length !== guestData?.count &&
                  !isSelectedAll
                ) {
                  handleSelectAllChange({ target: { checked: false } });
                }
              }}
            >
              <InputCheckbox
                label={
                  isSelectedAll
                    ? `${guestData?.count} Selected`
                    : selectedGuests.length
                    ? `${selectedGuests.length} Selected`
                    : "Select All"
                }
                onChange={(e) => handleSelectAllChange(e)}
                checked={
                  isSelectedAll || selectedGuests.length === guestData?.count
                }
                indeterminate={
                  selectedGuests.length &&
                  selectedGuests.length !== guestData?.count &&
                  !isSelectedAll
                }
              />
            </Box>
          )}
          <Box my={4}>
            {/* <Divider pad="xx-small" padPosition="vertical" /> */}
          </Box>
          {guestList?.length ? (
            <div>
              <Box
                id="share-container-scroll-div"
                className="custom-scrollbar"
                fullWidth
                sx={{ maxHeight: "250px", overflow: "auto", pr: "12px" }}
                // onScroll={(e) => {
                //   handleScroll(e);
                // }}
              >
                {guestList.map((item, i) => {
                  return (
                    <>
                      <Box
                        width={"100%"}
                        key={i}
                        ref={i + 1 == guestList.length ? lastElementRef : null}
                      >
                        <Container
                          fullWidth
                          verticalAlign="center"
                          horizontalAlign="space-between"
                        >
                          <Box
                            sx={{
                              "& .j-JDSCheckbox-horizontal-container": {
                                gap: "14px",
                              },
                              "& .j-JDSCheckbox-label-jds-text": {
                                fontFamily: "var(--font-families-body-m)",
                                color: "var(--color-primary-gray)",
                              },
                            }}
                          >
                            <InputCheckbox
                              label={`${item?.firstName || ""} ${
                                item?.lastName || ""
                              }`}
                              checked={item?.isSelected}
                              onChange={(e) =>
                                handleCheckboxChange(item?.id, e.target.checked)
                              }
                            />
                          </Box>
                        </Container>
                        {guestList.length - 1 !== i && (
                          <Box my={2}>
                            <Divider pad="none" padPosition="vertical" />
                          </Box>
                        )}
                      </Box>
                    </>
                  );
                })}
              </Box>
              <Container
                horizontalAlign="center"
                gap={24}
                style={{ marginTop: "32px" }}
                fullWidth
              >
                <Button
                  label="Approve"
                  size="large"
                  loading={isSharingAccess || false}
                  disabled={selectedGuests.length ? false : true}
                  onClick={() => giveApproveHandler("2")}
                  kind="secondary"
                />
                <Button
                  label="Deny"
                  size="large"
                  loading={isSharingAccess || false}
                  disabled={selectedGuests.length ? false : true}
                  onClick={() => giveApproveHandler("3")}
                  kind="secondary"
                  state="destructive"
                />
              </Container>
            </div>
          ) : (
            <EmptyState title="No guests found!" action={false} />
          )}
        </Box>
      )}
    </>
  );
}
